<template>
    <div class="employee-page">
      <div class="header-container">
        <picture class="header-picture">
          <source media="(max-width: 767px)" srcset="https://cdn.shopify.com/s/files/1/1363/8433/files/Curated_Header_Mobile.png?v=1744720211">
          <img  class="main-image" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Curated_Header.png?v=1744720210"/>
        </picture>
        <div class="title-container">
          <p class="title">Shop Gift Sets</p>
          <p class="subtitle desktop">Unique gifts, expertly curated</p>
          <div class="instructions">
            <div class="first">
              <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/address.svg?v=1721239631"/>
              <p>Ship via email</p>
            </div>
            <div>
              <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/ship_f963b592-b5a1-4844-bb0b-78bd22e5671a.svg?v=1725918596"/>
              <p >Bulk shipping</p>
            </div>
            <div class="last">
              <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/note.svg?v=1721239631"/>
              <p>Handwritten cards</p>
            </div>
          </div>
        </div>
      </div>
      <div class="main-container">
        <ul v-if="!sortedProducts || sortedProducts.length == 0" class="products-container no-scrollbar">
          <li v-for="n in 12" :key="n">
            <AddonProductSkeleton v-for="n in 12" :key="n" />
          </li>
        </ul>
        <div class="products-wrapper" v-else>
          <ul class="products-container no-scrollbar best-sellers">
            <p class="main-title">Shop <span>Best Selling</span> Curated Gifts</p>
            <div class="mobile sellers">
              <Flicking ref="featured" class="flicking-bs-collection" :plugins="plugins1" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: 2,bound: true, easing: x => 1 - Math.pow(1 - x, 3), defaultIndex: 1 }">
                <li v-for="product in bestSellers" :key="product.id + 'bestm'">
                  <div class="product-container slider" @click="selectProduct(product)">
                    <div class="product-image-container">
                      <img class="lazyload main-image" width="280" height="280" :data-src="product | getProductImage">
                    </div>
                    <button class="happybox-button white border" @click="selectProduct(product)">Shop: {{product.title}}</button>
                  </div>
                </li>
            </Flicking>
            </div>
          </ul>
          <div class="buttons-container">
              <button class="happybox-button white border" :class=" totalCurrentFilters > 0 ? 'selected' : ''" @click="showFilters()">
                  <img v-if="totalCurrentFilters > 0" class="purple" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"/>
                  <img v-else class="normal" src="https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"/>
                  <span class="desktop">Filters</span> 
                  <span class="mobile">Filter by Occasion</span> 
                  <span v-if="totalCurrentFilters > 0">({{ totalCurrentFilters }})</span>
              </button>
              <button class="happybox-button white border" @click="showSort()"><img src="https://cdn.shopify.com/s/files/1/1363/8433/files/Group_4412.png?v=1722267051"/>Sort</button>
          </div>
          <ul id="recoProducts" v-if="showReco" class="products-container no-scrollbar">
            <template v-for="set in occasionProducts">
              <p class="other-gifts">{{set.occasion}} Gifts</p>
              <li v-for="product in set.products" :key="product.id + set.occasion">
                <div class="product-container" @click="selectProduct(product)">
                  <div class="product-image-container">
                    <img class="lazyload main-image" width="280" height="280" :data-src="product | getProductImage">
                  </div>
                    <button class="happybox-button white border" @click="selectProduct(product)">Add to cart </button>
                    <p class="title">{{product.title}}</p>
                    <div class="product-price-container">
                      <span v-if="product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price" class="discount-price">{{product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price | moneySaleFormat}}</span>
                      <span class="price">{{product | moneyFormat}}</span>
                    </div>
                </div>
              </li>
            </template>
          </ul>
          <ul id="allProducts" v-else class="products-container no-scrollbar">
            <p class="other-gifts">{{breadcrumbText}}</p>
            <li v-for="product in sortedProducts" :key="product.id">
                <div class="product-container" @click="selectProduct(product)">
                  <div class="product-image-container">
                    <img class="lazyload main-image" width="280" height="280" :data-src="product | getProductImage">
                  </div>
                    <button class="happybox-button white border" @click="selectProduct(product)">Add to cart </button>
                    <p class="title">{{product.title}}</p>
                    <div class="product-price-container">
                      <span v-if="product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price" class="discount-price">{{product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price | moneySaleFormat}}</span>
                      <span class="price">{{product | moneyFormat}}</span>
                    </div>
                </div>
              </li>
              <p class="other-gifts" v-if="nonFilteredProducts.length > 0">All Other Gifts</p>
              <li v-for="product in nonFilteredProducts" :key="product.id">
                <div class="product-container" @click="selectProduct(product)">
                  <div class="product-image-container">
                    <img class="lazyload main-image" width="280" height="280" :data-src="product | getProductImage">
                  </div>
                    <button class="happybox-button white border" @click="selectProduct(product)">Add to cart </button>
                    <p class="title">{{product.title}}</p>
                    <div class="product-price-container">
                      <span v-if="product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price" class="discount-price">{{product.variants.find(x => x.price != '' && x.price != '0.00').compare_at_price | moneySaleFormat}}</span>
                      <span class="price">{{product | moneyFormat}}</span>
                    </div>
                </div>
              </li>
          </ul>
        </div>
      </div>
      <FiltersMobile :filteredPreAddons="filteredPreProducts" @closefilter="showFilters()" v-if="filterIsShown" :filteredAddons="sortedProducts"/>
      <SortMobile @closefilter="showSort()" v-if="sortIsShown"/>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import AddonProductSkeleton from './Skeletons/AddonProductSkeleton.vue'
  import FiltersMobile from './Filters/FiltersMobile.vue'
  import SortMobile from './Filters/SortMobile.vue'
  import VueSlickCarousel from 'vue-slick-carousel'
  import { AutoPlay } from "@egjs/flicking-plugins";

  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  require('dotenv').config();
  export default {
    components:{
      AddonProductSkeleton,
      FiltersMobile,
      SortMobile,
      VueSlickCarousel
    },
    watch:{
      showReco:{
        handler(val, oldVal){
          this.$nextTick(() => {
            if(val){
              document.getElementById('recoProducts').scrollIntoView();
            }
            else{
              document.getElementById('allProducts').scrollIntoView();
            }
          });
        },
      }
    },
    data(){
      return{
        filterIsShown: false,
        sortIsShown: false,
        plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: true })],
      }
    },
    computed:{
      ...mapGetters([
        'collectionProducts',
        'selectedSort',
        'selectedOccasion',
        'rangePrice',
        'occasions',
        'selectedOccasion'
      ]),
      bestSellers(){
        let bestSellers = this.collectionProducts.filter(x => x.tags.some(y => y.includes("Best Sellers")))
        if(bestSellers && bestSellers.length > 0)
          return bestSellers;
        return this.collectionProducts.slice(0,4);
      },
      totalCurrentFilters(){
        let total = this.selectedOccasion.filter(x => x != "View All").length;
        return total
      },
      breadcrumbText(){
        if(this.selectedOccasion.length == 1){
          return `${this.selectedOccasion} Gifts`;
        }
        return this.selectedOccasion.join(", ");
      },
      showReco(){
        return this.selectedOccasion.includes("View All") && this.selectedSort == 1;
      },
      occasionProducts() {
        let products = [];
        if (this.occasions && this.occasions.length > 0) {
          for (let [i, occasion] of this.occasions.entries()) {
            let filterAddons = JSON.parse(JSON.stringify(this.collectionProducts));
            let current = filterAddons.filter(x => x.tags.some(y => y.includes(occasion.title)) && ((parseFloat(x.variants[0].price) - this.rangePrice.min) * (parseFloat(x.variants[0].price) - this.rangePrice.max) <= 0));
            if (current.length > 0) {
              switch (this.selectedSort) {
                case "2":
                  current.sort((a, b) => {
                    var aIsIncluded = a.tags.some(x => x.includes("Best Sellers"));
                    var bIsIncluded = b.tags.some(x => x.includes("Best Sellers"));
                    if (aIsIncluded == bIsIncluded) {
                      return 0;
                    } else if (aIsIncluded == true) {
                      return -1;
                    } else if (bIsIncluded == true) {
                      return 1;
                    }
                  });
                  break
                case "3":
                  current.sort((a, b) => {
                    var aIsIncluded = this.dateDiffInDays(new Date(a.published_at), new Date()) < 60;
                    var bIsIncluded = this.dateDiffInDays(new Date(b.published_at), new Date()) < 60;
                    if (aIsIncluded == bIsIncluded) {
                      return 0;
                    } else if (aIsIncluded == true) {
                      return -1;
                    } else if (bIsIncluded == true) {
                      return 1;
                    }
                  })
                  break
                case "4":
                  current.sort((a, b) => {
                    return a.variants[0].price - b.variants[0].price
                  });
                  break;
                case "5":
                  current.sort((a, b) => {
                    return b.variants[0].price - a.variants[0].price
                  })
                  break;
                case "6":
                  current.sort((a,b) => { 
                    return b.variants[0].inventory_quantity - a.variants[0].inventory_quantity;
                  });
                  break;
                default:
                  break;
              }
              if (i == 0) {
                current.splice(7, 0, "ad");
              }
              products.push({
                occasion: occasion.title,
                products: current
              });
            }
          }
        }
        products.sort((a, b) => {
          let iA = a.occasion.includes("Brandable Swag") ? 1 : 0;
          let iB = b.occasion.includes("Brandable Swag") ? 1 : 0;
          return iA - iB;
        })
        if (!this.selectedOccasion.includes("View All")) {
          products.sort((a, b) => {
            let iA = this.selectedOccasion.includes(a.occasion) ? 1 : 0;
            let iB = this.selectedOccasion.includes(b.occasion) ? 1 : 0;
            return iB - iA;
          })
        }
        return products
      },
      filteredPreProducts() {
        let filterAddons = JSON.parse(JSON.stringify(this.collectionProducts));
        //filter via occasion
        if (!this.selectedOccasion.includes("View All")) {
          filterAddons = filterAddons.filter(x => x.tags.some(y => this.selectedOccasion.some(z => y.includes(z))));
        }

        return filterAddons;
      },
      filteredProducts() {
        //Filter Price
        return this.filteredPreProducts.filter(x => ((parseFloat(x.variants[0].price) - this.rangePrice.min) * (parseFloat(x.variants[0].price) - this.rangePrice.max) <= 0));
      },
      nonFilteredProducts() {
        let ids = this.filteredProducts.map(x => x.id);
        return this.collectionProducts.filter(x => !ids.includes(x.id));
      },
      sortedProducts(){
        var sortedProducts = JSON.parse(JSON.stringify(this.filteredProducts));
        switch (this.selectedSort) {
          case "2":
          sortedProducts.sort((a, b) => {
              var aIsIncluded = a.tags.some(x => x.includes("Best Sellers"));
              var bIsIncluded = b.tags.some(x => x.includes("Best Sellers"));
              if (aIsIncluded == bIsIncluded) {
                return 0;
              } else if (aIsIncluded == true) {
                return -1;
              } else if (bIsIncluded == true) {
                return 1;
              }
            });
            break
          case "3":
          sortedProducts.sort((a, b) => {
              var aIsIncluded = this.dateDiffInDays(new Date(a.published_at), new Date()) < 60;
              var bIsIncluded = this.dateDiffInDays(new Date(b.published_at), new Date()) < 60;
              if (aIsIncluded == bIsIncluded) {
                return 0;
              } else if (aIsIncluded == true) {
                return -1;
              } else if (bIsIncluded == true) {
                return 1;
              }
            })
            break
          case "4":
          sortedProducts.sort((a, b) => {
              return a.variants[0].price - b.variants[0].price
            });
            break;
          case "5":
          sortedProducts.sort((a, b) => {
              return b.variants[0].price - a.variants[0].price
            })
            break;
          case "6":
            sortedProducts.sort((a,b) => { 
              return b.variants[0].inventory_quantity - a.variants[0].inventory_quantity;
            });
            break;
          default:
            break;
        }
  
        return sortedProducts.filter(x => x.variants.some(y => y.available));
      },
    },
    methods:{
      showFilters(){
        this.filterIsShown = !this.filterIsShown;
      },
      showSort(){
        this.sortIsShown = !this.sortIsShown;
      },
      selectProduct(product){
        history.pushState(null,"",`/products/${product.handle}`);
        $(window).scrollTop(0);
        this.$store.commit("setSelectedProduct",product)
      },
      setSelectedOccasion(value){
        let newValue = JSON.parse(JSON.stringify(value));
        this.$store.commit('setSelectedOccasion', newValue );
        this.$store.commit('setSelectedOccasionMobile', newValue );
      },
      dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      },
    },
    mounted(){
    },
    destroy() {
    }
  }
  </script>
  
  <style scoped>

  .header-container{
    width: 100%;
    display: flex;
    position: relative;
  }

  .header-container picture{
    width: 100%;
  }

  .header-container .main-image{
    width: 100%;
  }

.title-container{
    width: 50%;
    position: absolute;
    top: 0%;
    left: 21%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.title-container .title{
    font-size: 4.5vw;
    line-height: 0.8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 1rem;
}

.title-container .subtitle{
  font-size: 1.3vw;
  margin-bottom: 0.5rem;
  color: white;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.title-container .instructions div{
    width: 26%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 4vw;
}

.title-container .instructions div p{
  font-size: 1vw;
}

.title-container .instructions .first img{
    max-width: 40%;
}

.title-container .instructions .last img{
    padding: 2%;
}

.title-container .instructions div{
    font-size: 1.2vw;
    line-height: 1.2;
    font-weight: bold;
}

.main-container{
  width: 100%;
  padding: 0 10%;
}

.main-container .products-container{
    width: 100%;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    gap: 15px 2.66%;
}

.main-container .products-container.best-sellers{
  border: 1px solid #0f0c38;
  border-radius: 8px;
  padding: 2% 5%;
  background-color: #fffceb;
  display: none;
}

.products-container.best-sellers .main-title{
  font-size: 2vw;
  font-weight: bold;
  width: 100%;
  margin: unset;
  text-align: center;
}

.products-container li{
  width: 23%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.products-container li .product-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.products-container li .product-container .product-image-container{
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  margin-bottom: 0.5rem;
}

.products-container li .product-container .product-image-container .main-image{
  width: 100%;
  background-color: #F6F6F6;
  cursor: pointer;
  height: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.products-container li .product-container .title{
  font-weight: 700;
  font-size: 1.1vw;
  line-height: 1.5;
  margin-top: 2%;
  margin-bottom: 0;
}

.products-container li .product-container .product-price-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1vw;
  line-height: 1.43;
  padding-bottom: 5%;
}

.products-container li .product-container .product-price-container .price{
  color: #3F3D60;
}

.products-container li .product-container .product-price-container .discount-price{
  color: red;
  text-decoration: line-through;
  padding-right: 5%;
}

  .products-wrapper{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 2%;
    gap: 15px;
  }

  .products-wrapper .buttons-container{
    display: flex;
    gap: 5%;
    flex: 1;
    width: 50%;
  }

  .products-wrapper .buttons-container button{
    display: flex;
    gap: 5px;
    align-items: center;
    padding: 1% 5%;
  }

  .products-wrapper .buttons-container button.selected{
    color: #a01adb;
    font-weight: 700;
    border: 1px solid #a01adb;
  }

  .products-wrapper .buttons-container button.selected span{
    color: #a01adb;
    font-weight: 700;
  }

  .products-wrapper .buttons-container button img{
    width: 15px;
    padding: unset
  }

  .other-gifts{
    width: 100%;
    font-family: ff-more-web-pro-condensed, Karla, sans-serif;
    text-transform: capitalize;
    font-weight: 300;
    font-size: 2vw;
    margin: unset;
  }

.filter-categories-container{
  display: none
}
  
  @media only screen and (max-device-width: 767px){

    .main-container,.products-wrapper{
      padding: unset;
      gap: 5px;
    }

    .products-wrapper .buttons-container{
      width: 100%;
      padding: 2% 3%;
      position: sticky;
      top: 80px;
      background-color: white;
      z-index: 1;
      gap: 5px;
    }

    .products-wrapper .buttons-container button{
      font-size: 3vw;
      padding: 1% 2.5%;
    }

    .other-gifts{
      width: 100%;
      border-bottom: 0.5px solid gray;
      margin-bottom: 4%;
      font-size: 5vw;      
    }

    .main-container .products-container{
      gap: unset;
      padding: 0% 5%;
      scroll-margin: 120px;
    }

    .products-container li{
      width: 50%;
      display: inline-block;
      padding: 0% 1.5%;
      flex-shrink: 0;
    }

    .products-container li .product-container .title,.products-container li .product-container .product-price-container{
      font-size: 1rem;
      line-height: 1.2;
    }

    .product-container.slider{
      background-color: white;
      border-radius: 8px;
      border: 1px solid black;
      padding-bottom: 5%;
      position: relative;
    }

    .product-container.slider .happybox-button{
      width: 90%;
      padding: 0.2rem 0;
      margin-left: 5%;
      font-size: 2vw;
    }

    .products-container li .product-container.slider .product-image-container .main-image{
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    .products-container li .product-container.slider .title,.products-container li .product-container.slider .product-price-container{
      padding: 0% 5%;
      font-size: 2.8vw;
    }

    .filter-categories-container{
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0% 2%;
        box-shadow: 0 1px #0003;
        position: sticky;
        top: 80px;
        z-index: 1;
        background-color: white;
    }

    .filter-categories-container .title{
        flex: 2;
        font-size: 3vw;
        display: flex;
        gap: 5px;
        font-weight: bold;
        align-items: center;
        margin: unset;
    }

    .filter-categories-container .title img{
        width: 15px;
    }

    .filter-categories-container .white{
        font-size: 3vw;
        flex: 2;
        padding: 0.5%;
    }

    .categories-container{
    flex: 4;
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 2% 0%;
}

.categories-container button{
    margin: 0% 1%;
    font-family: 'Karla';
    font-style: normal;
    font-weight: 400;
    font-size: 2.5vw;
    line-height: 1.3;
    color: #7A7991;
    padding: 2%;
    border-radius: 20px;
    border: 1px solid lightgray;
}

.categories-container button.selected{
    color: white;
    background-color: #0F0C38;
}

.products-container.best-sellers .main-title{
  font-size: 6vw;
  font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
  font-weight: 300;
  margin-bottom: 1rem;
}

.products-container.best-sellers .main-title span{
  font-style: italic;
}

.sellers{
  width: 100%;
}

.main-container .products-container.best-sellers{
  border-radius: 0;
  padding: 2% 0%;
  background-color: white;
  border: unset;
  display: flex;
  margin-top: -10rem;
  z-index: 1;
  background-color: unset;
}

.title-container{
    width: 100%;
    position: absolute;
    top: 15%;
    left: 0%;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding-top: 2rem;
}

.title-container .title{
    font-size: 14vw;
    line-height: 1;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 0rem;
    padding-left: 2rem;
    text-align: left;
    white-space: break-spaces;
    width: 50%;
}

.title-container .subtitle{
  font-size: 3.5vw;
  padding-left: 1rem;
}

.title-container .instructions{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    padding: 0 2rem;
    margin-top: 1rem;
}

.title-container .instructions div{
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-container .instructions div img{
    margin-bottom: 0.5rem;
    height: 8vw;
    max-width: 100%;
}

.title-container .instructions div p{
    font-size: 2.5vw;
    line-height: 1.2;
    font-weight: bold;
}
  }
   
  </style>

  <style>
  .sellers .slick-slider{
    width: 100%;
    margin: unset;
  }
</style>